window.login = function() {
    const initForm = () => {
        $("form").each(function() {
            $(this).validate({
                ignore: null,
                rules: {
                    email: {
                        required: true,
                        maxlength: 255,
                        email: true,
                    },
                    password: {
                        required: true,
                        minlength: 8
                    },
                    hiddenRecaptcha: {
                        required: function () {
                            if (grecaptcha.getResponse() == '') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                },
                messages: {
                    hiddenRecaptcha: {
                        required: "Please check the box below proceed"
                    }
                },
                highlight: function (element) {
                    $(element).closest('.formInput').addClass('formError');
                },
                unhighlight: function(element) {
                    $(element).closest('.formInput').removeClass('formError');
                },
                errorPlacement: function(error, element) {
                    if (element.attr("type") == "checkbox") {
                        error.insertAfter(element.closest('div.accessForm__wrap'));
                    } else if (element.attr("name") == "hiddenRecaptcha") {
                        error.insertAfter(element.closest('div.center-flex'));
                    } else {
                        error.insertAfter(element);
                    }
                },
                errorElement: 'div',
                errorClass: 'formError__txt display-flex',
            });
        });
    };
    
    return {
        init: function() {
            initForm();
        }
    };
}();

window.register = function() {
    const initForm = () => {
        $("form").each(function() {
            $(this).validate({
                ignore: null,
                rules: {
                    email: {
                        required: true,
                        maxlength: 255,
                        email: true,
                    },
                    password: {
                        required: true,
                        minlength: 8
                    },
                    hiddenRecaptcha: {
                        required: function () {
                            if (grecaptcha.getResponse() == '') {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    },
                    term: {
                        required: true,
                    }
                },
                messages: {
                    hiddenRecaptcha: {
                        required: "Please check the box below proceed"
                    }
                },
                highlight: function (element) {
                    $(element).closest('.formInput').addClass('formError');
                },
                unhighlight: function(element) {
                    $(element).closest('.formInput').removeClass('formError');
                },
                errorPlacement: function(error, element) {
                    if (element.attr("type") == "checkbox") {
                        error.insertAfter(element.closest('div.accessForm__wrap'));
                    } else if (element.attr("name") == "hiddenRecaptcha") {
                        error.insertAfter(element.closest('div.center-flex'));
                    } else {
                        error.insertAfter(element);
                    }
                },
                errorElement: 'div',
                errorClass: 'formError__txt display-flex',
            });
        });
    };
    
    return {
        init: function() {
            initForm();
        }
    };
}();

window.forgotPassword = function() {
    const initForm = () => {
        $("form").each(function() {
            $(this).validate({
                rules: {
                    email: {
                        required: true,
                        maxlength: 255,
                        email: true,
                    },
                },
                errorPlacement: function(error, element) {
                    error.insertAfter(element);
                },
                highlight: function (element) {
                    $(element).closest('.formInput').addClass('formError');
                },
                unhighlight: function(element) {
                    $(element).closest('.formInput').removeClass('formError');
                },
                errorElement: 'div',
                errorClass: 'formError__txt display-flex',
            });
        });
    };
    
    return {
        init: function() {
            initForm();
        }
    };
}();

window.resetPassword = function() {
    const initForm = () => {
        $("form").each(function() {
            $(this).validate({
                rules: {
                    email: {
                        required: true,
                        maxlength: 255,
                        email: true,
                    },
                    password: {
                        required: true,
                        minlength: 8
                    },
                    password_confirmation: {
                        required: true,
                        minlength: 8,
                        equalTo: "#password"
                    },
                },
                highlight: function (element) {
                    $(element).closest('.formInput').addClass('formError');
                },
                unhighlight: function(element) {
                    $(element).closest('.formInput').removeClass('formError');
                },
                errorPlacement: function(error, element) {
                    error.insertAfter(element);
                },
                errorElement: 'div',
                errorClass: 'formError__txt display-flex',
            });
        });
    };
    
    return {
        init: function() {
            initForm();
        }
    };
}();